import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { ImportError } from '../../../models';
import { createReducer, on } from '@ngrx/store';
import * as AdminActions from '../actions/admin.actions';

export const importErrorsFeatureKey = 'importErrors';

export interface ImportErrorState extends EntityState<ImportError> {
  importErrors: ImportError[];
  currentPage: number;
}

export const importErrorAdapter: EntityAdapter<ImportError> =
  createEntityAdapter<ImportError>();

export const importErrorInitialState: ImportErrorState =
  importErrorAdapter.getInitialState({
    importErrors: [],
    currentPage: 1,
  });

export const importErrorReducer = createReducer(
  importErrorInitialState,
  on(AdminActions.loadImportErrors, (state, action) =>
    importErrorAdapter.setAll(action.importErrors, state)
  ),
  on(AdminActions.upsertImportErrors, (state, action) =>
    importErrorAdapter.upsertMany(action.importErrors, state)
  ),
  on(AdminActions.setImportErrorCurrentPage, (state, action) => ({
    ...state,
    currentPage: action.pageNo,
  })),
  on(AdminActions.resetImportErrors, (state) =>
    importErrorAdapter.removeAll(state)
  ),
  on(AdminActions.importMissingRecipes, (state, action) => {
    const { clientId, recipeIds } = action;
    // TODO: Fix this so it selects all import errors where any recipeIds are in the objectId field
    const importErrorIdsToRemove =
      selectAll(state)
        .filter((importError) =>
          recipeIds.some(
            (recipeId) =>
              importError.clientId === clientId &&
              (importError.code === 'NotAllMenuClientProductMappingsFound' ||
                importError.code === 'ClientProductMappingNotFound') &&
              importError.objectId.includes(recipeId.toString())
          )
        )
        .map((importError) => importError?.id) ?? [];
    return importErrorAdapter.removeMany(importErrorIdsToRemove, state);
  }),
  on(AdminActions.importMissingMenu, (state, action) => {
    const { menu } = action;
    const importErrorIdsToRemove =
      selectAll(state)
        .filter((importError) => {
          // Parse the menu date from the DTO (format: YYYY-MM-DD)
          const menuDate = new Date(menu.date);
          // Get the import error date (already a Date object)
          const errorDate = new Date(importError.date);

          // Compare dates by converting both to date strings (YYYY-MM-DD)
          const menuDateString = menuDate.toISOString().split('T')[0];
          const errorDateString = errorDate.toISOString().split('T')[0];

          return (
            importError.clientId === menu.clientId &&
            importError.locationId === menu.locationId &&
            importError.objectId === menu.menuId.toString() &&
            importError.code === 'NotAllMenuItemsFound' &&
            menuDateString === errorDateString
          );
        })
        .map((importError) => importError?.id) ?? [];
    return importErrorAdapter.removeMany(importErrorIdsToRemove, state);
  }),
  on(AdminActions.resetImportErrorCurrentPage, (state) => ({
    ...state,
    currentPage: 1,
  }))
);

export const { selectIds, selectEntities, selectAll, selectTotal } =
  importErrorAdapter.getSelectors();

